<ion-grid class="dashboard-table">

  <!-- Header -->
  <ion-row class="dashboard-table-header">
    <ion-col *ngFor="let col of columns" [size]="col.size" [class]="col.headerClass">
      {{ col.title | translate }}
    </ion-col>
  </ion-row>

  <ng-container *ngIf="outputData?.length > 0; else noDataTemplate">
    <ion-row *ngFor="let row of outputData" class="dashboard-table-row" (click)="clickHandler($event, row)">
      <ion-col *ngFor="let col of columns" [size]="col.size">
        <ng-container [ngSwitch]="col.renderType">

          <!-- Text -->
          <ng-container *ngSwitchCase="'text'">
            <ng-container *ngIf="col.format; else raw">
              {{ row[col.key] | number: col.format }} {{ col.unit || '' }}
            </ng-container>
            <ng-template #raw>
              {{ row[col.key] }}
            </ng-template>
          </ng-container>

          <!-- Progress Bar -->
          <ng-container *ngSwitchCase="'progress'">
            <div class="progress-bar-wrapper">
              <div class="progress-bar">
                <div class="progress-fill"
                  [ngClass]="getProgressLevelClass(row[col.progressKeys?.percent])"
                  [style.width.%]="row[col.progressKeys?.percent]"></div>
              </div>
              <span class="progress-text">
                <ng-container [ngSwitch]="col.format">
                  <ng-container *ngSwitchCase="'/'">
                    {{ row[col.progressKeys?.completed] }}/{{ row[col.progressKeys?.total] }}
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ row[col.progressKeys?.percent] | number:'1.2-2' }}%
                  </ng-container>
                </ng-container>
              </span>
            </div>
          </ng-container>

          <!-- Chip -->
          <ng-container *ngSwitchCase="'chip'">
            <ion-chip class="improvement-chip" [ngClass]="getImprovementClass(row.improvementText)">
              {{ row[col.key] }}
            </ion-chip>
          </ng-container>

        </ng-container>
      </ion-col>
      <ion-col size="0.3" class="arrow-col">
        <img class="row-arrow" src="assets/icon/arrow-blue.svg" alt="" />
      </ion-col>
    </ion-row>
  </ng-container>

  <!-- If data empty -->
  <ng-template #noDataTemplate>
    <ion-row class="dashboard-table-row no-data-row">
      <ion-col [size]="12" class="no-data-cell" style="text-align: center;">
        <span>{{ "__CALLS_DATA_IS_EMPTY__" | translate }}</span>
      </ion-col>
    </ion-row>
  </ng-template>

</ion-grid>
